<template class="section">

  <section class="home">

    <div id="home">

      <!-- Title, motto and join button-->
      <div class="container" id="home-container">

        <section class="section">


          <div class="container" id="motto-container">
            <h4 id="motto">Ett medlemskap -<br>en verden av trening</h4>

            <h2 id="motto-long"></h2> <br>
            <!--  <router-link to=""><a class="button is-primary" id="btn-blimedlem-header">Bli med</a></router-link> -->
            <router-link to="sign-up"><a class="button is-primary" id="btn-lesmer-header">Les mer</a></router-link>
          </div>
        </section>
        <br>
      </div>
    </div>

    <div class="" id="all-below-image">



      <!--NEWSLETTER SIGNUP
      <section :class="{'is-hidden' : isMobile}">
        <div class="notification has-text-centered is-mailing-list">

          <div class="columns">

            <div class="column is-centered is-7">
              <p id="mailing-text">Meld deg på vårt nyhetsbrev og bli den første til å vite når Combine lanseres!</p>
            </div>

            <div class="column" id="mailing-input-column">

              <div class="field has-addons" id="mailing-input">

                <div class="control">
                  <input class="input" type="email" placeholder="Epost" id="mailing-input" v-model="mailinglistEmail">
                </div>

                <div class="control">
                  <button class="button" id="mailing-list-btn" @click="signUpForMailingList(mailinglistEmail)">
                    Meld på
                  </button>
                </div>

              </div>
            </div>


          </div>

        </div>

        <div class="modal" :class="{'is-active' : isSignedUpMailingListModal()}">
          <div class="modal-background" @click="signedUpMailingListModal = false"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title has-text-centered">Du er nå påmeldt vårt nyhetsbrev!</p>
              <button class="delete" @click="signedUpMailingListModal = false" aria-label="close"></button>
            </header>
            <section class="modal-card-body">

            </section>
          </div>
        </div>

      </section>-->

      <div class="container has-text-centered">
        <h1 class="title is-3" id="test-title"></h1>
      </div>



      <section class="perks">

        <div class="container">

          <div class="columns" id="perk-container">

            <div class="column is-one-third">
              <img src="../assets/perk_1.png" alt="" id="perks-image">
            </div>

            <div class="column is-one-third perk-image-column">
              <div id="perks-text-container">
                <h1 id="perk-header">Flere medlemskap til prisen av ett</h1>
                <p id="perk-paragraph">Med Combine får du tilgang til ulike aktiviteter på flere sentre. Det gir en unik mulighet til en variert og spennende treningshverdag.</p>
                <br> <router-link to="prices"><button class="button" id="perks-button">Se priser</button></router-link>
              </div>
            </div>

          </div>



          <div class="columns" id="perk-container">
            <div class="column">

            </div>

            <div class="column is-half">
              <div id="perks-text-container">
                <h1 id="perk-header-2">Tren hva du vil, <br> når <p id="underline">du vil.</p></h1>
                <p id="perk-paragraph-2"></p>
              </div>
            </div>

            <div :class="{'column' : !isMobile,  'is-half' : !isMobile, 'is-hidden' : isMobile}">
              <img src="../assets/perk_2.png" alt="" id="perks-image">
            </div>

          </div>


          <div class="columns" id="perk-container">

            <div class="column is-one-third">
              <img src="../assets/perk_3.png" alt="" id="perks-image">
            </div>


            <div class="column is-one-third">
              <div id="perks-text-container-3">
                <h1 id="perk-header">Variasjon</h1>
                <p id="perk-paragraph">Med Combine får du tilgang til yoga, pilates, barre, klatring, styrke og kondisjon.</p><br>
                <button class="button" id="perks-button">Bli medlem</button>
              </div>
            </div>


          </div>


        </div>
      </section>




      <div class="container" id="faq-container">

        <div class="prices-header has-text-centered">
          <img src="../assets/about.svg" alt=""></img><br><br>
        </div>

        <a class="content" id="faq-content" v-on:click="setActiveFaq('q1')" v-bind:class="{ 'is-active-faq': isActiveFaq('q1')}">
          <h1 class="control has-icons-left has-icons-right" id="faq-header">Hva er Combine?<span class="icon is-right" v-bind:class="{ 'is-active-faq': isActiveFaq('q1')}"><i class="fas fa-angle-down fa-lg"></i></span> </h1>
          <p id="faq-p" v-if="isActiveFaq('q1')" v-bind:class="{ 'is-active-faq': isActiveFaq('q1')}">Combine er et treningsmedlemskap som gir tilgang til flere ulike aktiviteter på eksisterende sentre. Som medlem kan du delta på
            gruppetimer av høy kvalitet, utført av instruktører som er spesialister på sitt område. For en fast pris i måneden kan du kombinere ulike medlemskap i ett. Det gjør det enklere, billigere og ikke
            minst enda mer gøy å trene. </p>
            <div class="divider"></div>
          </a>

          <a class="content" id="faq-content" v-on:click="setActiveFaq('q2')" v-bind:class="{ 'is-active-faq': isActiveFaq('q2')}">
            <h1 class="control has-icons-left has-icons-right" id="faq-header">Hvorfor bli medlem?<span class="icon is-right" v-bind:class="{ 'is-active-faq': isActiveFaq('q2')}"><i class="fas fa-angle-down fa-lg"></i></span> </h1>
            <p id="faq-p" v-if="isActiveFaq('q2')" v-bind:class="{ 'is-active-faq': isActiveFaq('q2')}">Vi vil gjøre det lettere for deg å utforske ulike former for trening ved å samle alt i ett medlemskap. Vi har samlet flere
              tilbud i ett medlemskap slik at du kan trene variert. Kanskje er du en av de som elsker å kombinere forskjellige aktiviteter, eller kanskje du
              finner den treningsformen eller det senteret som passer akkurat for deg.</p>
              <div class="divider"></div>
            </a>

            <a class="content" id="faq-content" v-on:click="setActiveFaq('q3')" v-bind:class="{ 'is-active-faq': isActiveFaq('q3')}">
              <h1 class="control has-icons-left has-icons-right" id="faq-header">Hvordan fungerer det?<span class="icon is-right" v-bind:class="{ 'is-active-faq': isActiveFaq('q3')}"><i class="fas fa-angle-down fa-lg"></i></span> </h1>
              <p id="faq-p" v-if="isActiveFaq('q3')" v-bind:class="{ 'is-active-faq': isActiveFaq('q3')}">Du finner alle treningstilbudene under <router-link to="gyms"><a>Våre sentre</a></router-link>. Her får du en oversikt over alle tilgjengelige timer og kan enkelt melde deg på en time. Du vil
                da få en bekreftelse på mail, som du viser til de ansatte ved senteret. Hvis du likevel ikke kan delta på en påmeldt time sender du mail til <a href="mailto:info@combine.no?Subject=Combine" target="_top">info@combine.no.</a></p>
                <div class="divider"></div>
              </a>

            </div>


          </div>

          <!-- Footer -->
          <footer class="footer">
            <div class="container">
              <div class="content has-text-centered">
                <p>
                  C
                </p>
              </div>
            </div>
          </footer>

        </section>
      </template>

      <script>
      $(function () {
      $(document).scroll(function () {
      var $nav = $(".navbar");
      var $itm = $(".nb-itm");
      $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
      $nav.toggleClass('nb-itm-scrolled', $(this).scrollTop() > $nav.height());
    });
  });
  import Firebase from 'firebase'
  import Header from './Header.vue';

  export default {
    data() {
      return {
        scrollPos: 0,

        activeCity: 'Oslo',
        activeQ: '',

        mailinglistEmail: '',
        signedUpMailingListModal: false,

        isMobile: false,
      }
    },
    methods: {
      signUpForMailingList: function(email){

        this.signedUpMailingListModal = true;

        var mailListKey = Firebase.database().ref().child('mailinglist/').push().key;

        var updates = {};
        updates['mailinglist/' + mailListKey] = email;
        return Firebase.database().ref().update(updates);

      },
      isSignedUpMailingListModal: function(){
        return this.signedUpMailingListModal;
      },
      isActive: function(city) {
        return this.activeCity === city
      },
      setActive: function (city) {
        this.activeCity = city
      },
      isActiveFaq: function(q) {
        return this.activeQ === q
      },
      setActiveFaq: function (q) {
        if (this.activeQ === q){
          this.activeQ = '';
        } else {this.activeQ = q}
      },
    },
    created: function() {
      if (window.innerWidth < 769) {this.isMobile = true}
      else {this.isMobile = false};
    },
    components: {
      //  'classesoverview': Classes_overview,
      navMain: Header
    },

  }
</script>

<style lang="scss">

@font-face {
  font-family: Bebas Neue;
  src: url("../assets/fonts/BebasNeue-regular.otf") format("opentype");
}

@media screen and (max-width: 768px) {

  .home{
    background-color: #F5F7F9;
  }

  #motto-container {
    padding: 0.5rem;
  }

  #home {
    background-image: url("../assets/header_sweat_min.png");
    background-position: center;
    background-size: cover;
    height: 400px;
  }

  div.container#motto-container {
    text-align: center;
    margin-top: 110px;
  }

  h4#motto{
    font-size:2.4rem;
    color: white;
    line-height: 0.9;
    font-family: 'Impact';
    font-weight: 800;
    letter-spacing: 1px;
    text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  }

  .footer {
    color: black;
    border-top-width: thick;
    border-color: #00D2B2;
  }

  .card-content{
    padding: 30px;
  }
  .card-header-title{
    font-size: 28px;
  }

  #faq-container {
    padding-top: 120px;
    width: 300px;
    padding-bottom: 75px;
    font-family: 'Montserrat', sans-serif;
  }

  #faq-header{
    font-size: 1.2rem;
    padding-top: 10px;
  }
  .divider{
    border-top: 1px solid #D8D8D8;
  }

  p#faq-p{
    color: grey;
    font-size: 1rem;
  }

  span.icon.is-right.is-active-faq{
    transform: rotate(180deg);
    transition: 0.3s;
  }

  #perk-container{

  }

  .perk-image-column{
    margin-top: -100px;
    height: 100px;
  }

  #perk-header{
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    color: #18233E;
    font-family: 'Montserrat', sans-serif;
  }
  #perk-paragraph{
    text-align: center;
    font-size: 0.8rem;
    font-family: 'Montserrat', sans-serif;
    color: #18233E;
  }
  #perk-header-2{
    padding-top: 40px;
    padding-right: 20px;
    text-align: right;
    font-size: 2.5rem;
    font-weight: 800;
    color: #18233E;
    font-family: 'Montserrat', sans-serif;
  }
  #underline{
    border-bottom: 5px solid #18233E;
    display: inline-block;
  }
  #perk-paragraph-2{
    text-align: right;
    font-size: 18px;
    font-family: 'Montserrat', sans-serif;
    color: #18233E;
  }

  #perks-text-container{
    padding-top: 50px;
  }
  #perks-text-container-3{
    margin-top: -60px;
  }

  #perks-image{
    transform: scale(0.6);
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.05);
  }
  #perks-button{
    font-family: 'system-ui';
    border-radius: 0px;
    border-width: 0px;
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.02);
    background-color: #00D2B2;
    color: white;
    position: relative;
    margin-left: 35%;
  }

  .is-mailing-list{
    background-color: #18243E;
    height: 60px;
    border-radius: 0px;
    margin: auto;
    justify-content: center;
  }

  #perk-icon{
    padding-bottom: 40px;
    transform: scale(0.2);
    margin: -150px;
  }



}

@media screen and (min-width: 769px) {
  #mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif;}


#test-title{
  font-family: 'Montserrat';
}
  .home{
    background-color: #F5F7F9;
  }

  .perks{
    margin-top: 50px;
  }

  #motto-long {
    font-family: 'Montserrat', sans-serif;
    font-size: 20px;
    text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  }


  #home-container{
    margin-top: -0px;
  }

  #motto-container {
    color: white;
    width: 800px;
    transform: translateY(-80px);
  }

  #home {
    background-image: url("../assets/boyandgirl.jpeg");
    background-position: center;
    background-size: cover;
    height: 700px;
  }

  #fa-down{
    color: white;
    margin: auto;
    justify-content: center;
  }
  #fa-down-container{
    margin-top: -25px;
  }

  #bli-medlem-cards.columns {
    padding-top: 100px;
  }

  .blimedlem{
    background-color: #00D2B2;
  }

  #price-columns{
    border-radius: 0px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.13);
    border-color: #F4F7F9;
    border-width: 3px;
  }

  #price-columns:hover{
    border-radius: 0px;
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.21);
    transition: 0.5s;
  }


  .container.r {
    margin-top: 100px;
    font-size: 40px;
  }

  div.container#motto-container {
    max-height: 400px;
    text-align: center;
    margin-top: 260px;
  }

  .button.is-info{
    background-color: #00D2B2;

  }

  h1#title {
    color: #3a3a3a;
    font-size: 60px;
  }

  h4#motto{
    font-size:6rem;
    color: white;
    line-height: 0.9;
    font-family: 'Bebas Neue';
    font-weight: 800;
    letter-spacing: 1.5px;
    text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  }

  div#btn-blimedlem-meta{
    padding-top: 20px;
    margin-bottom: -5px;
  }

  #btn-blimedlem{
    font-size: 23px;
    width: 150px;
    background-color: #00D2B2;
    color: white;
  }
  #btn-blimedlem:hover{
    background-color: #5AAFAD;
    font-size: 23px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
    transition: all 0.5s
  }
  #btn-blimedlem-header{
    font-size: 18px;
    background-color: #00D2B2;
    border-radius: 2px;
    color: white;
  }
  #btn-blimedlem-header:hover{
    background-color: #1B9A95;
  }
  #btn-lesmer-header{
    font-family: 'system-ui';
    font-size: 16px;
    background-color: #00D2B2;
    border-width: 0px;
    border-radius: 1px;
    color: white;
  }
  #btn-lesmer-header:hover{
    background-color: #138F8B;
    color: white;
    transition: 0.3s;
  }

  #btn-bli-medlem-home:hover {
    background-color: white;
    color: #00D2B2;
    box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.2);
    transition: all 0.5s
  }

  .taster {
    margin-top: 100px;
  }


  .box.classes {
    background-color: #414141;
  }


  #btn-book {
    color: turquoise;
    background-color: white;
    border-color: white;
    border-radius: 49px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15);
  }
  #btn-book:hover {
    color: white;
    background-color: turquoise;
    border-color: turquoise;
    border-radius: 49px;
    box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.2);
    transition: all 0.5s
  }

  .footer {
    color: black;
    border-top-width: thick;
    border-color: #00D2B2;
  }

  #cost{
    font-size: 36px;
    font-family: 'system-ui';
    font-style: bold;
  }
  #muted{
    font-size: 20px;
    color: grey;
  }
  #list-item{
    font-size: 16px;
  }
  .card-content{
    padding: 30px;
  }
  .card-header-title{
    font-size: 28px;
  }


  .container#price-container{
    width: 800px;
    padding-bottom: 100px;
  }

  #faq-container {
    padding-top: 120px;
    width: 850px;
    padding-bottom: 75px;
    font-family: 'Montserrat', sans-serif;
  }

  #faq-header{
    font-size: 20px;
    padding-top: 10px;
  }
  .divider{
    border-top: 1px solid #D8D8D8;
  }

  .fa-chevron-down{
    color: grey;
  }

  #header-chevron-meta{

  }

  #header-chevron{
    color: white;
    transform: scale(1.6);
    display: inline-block;
    width: 100%;

  }

  p#faq-p{
    color: grey;
    font-size: 18px;
  }


  span.icon.is-right.is-active-faq{
    transform: rotate(180deg);
    transition: 0.3s;
  }


  section.container#price-container {
    padding-top: 150px;
  }

  #perk-container{
    margin-top: 60px;
  }

  #perk-header{
    font-size: 20px;
    font-weight: 600;
    color: #18233E;
    font-family: 'Montserrat', sans-serif;
  }
  #perk-paragraph{
    font-size: 18px;
    font-family: 'Montserrat', sans-serif;
    color: #18233E;
  }
  #perk-header-2{
    text-align: right;
    font-size: 50px;
    font-weight: 800;
    color: #18233E;
    font-family: 'Montserrat', sans-serif;
  }
  #underline{
    border-bottom: 5px solid #18233E;
    display: inline-block;
  }
  #perk-paragraph-2{
    text-align: right;
    font-size: 18px;
    font-family: 'Montserrat', sans-serif;
    color: #18233E;
  }

  #perks-text-container{
    padding-top: 50px;
  }
  #perks-text-container-3{
    padding-top: 30px;
  }

  #perks-image{
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.05);
  }
  #perks-button{
    font-family: 'system-ui';
    border-radius: 0px;
    border-width: 0px;
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.02);
    background-color: #00D2B2;
    color: white;
  }
  #perks-button:hover{
    border-radius: 0px;
    border-width: 0px;
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.04);
    background-color: #138F8B;
    color: white;
    transition: 0.3s;
  }

  .is-mailing-list{
    background-color: #18243E;
    height: 60px;
    border-radius: 0px;
  }

  #mailing-text{
    color: white;
  }
  #mailing-input{
    border-radius: 0px;
    width: 300px;
  }
  #mailing-input-column{
    padding-top: 5px;
  }
  #mailing-list-btn{
    background-color: #E3E5EA;
    color: black;
    font-family: 'Montserrat', sans-serif;
    border-radius: 0px;
    border-width: 0px;
  }
  #mailing-list-btn:hover{
    background-color: grey;
    transition: 0.3s;
  }

  /*#perks-column{
  margin-left: 10px;
  margin-right: 10px;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 45px;
  background-color: white;
  height: 320px;
  box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.1);
  }*/

  #perk-icon{
    padding-bottom: 40px;
    transform: scale(0.2);
    margin: -150px;
  }


}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue